/* import __COLOCATED_TEMPLATE__ from './impersonated-user-search-opener.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */
import type AppService from 'embercom/services/app-service';
import type UserSummary from 'embercom/objects/inbox/user-summary';
import Component from '@glimmer/component';
import safeWindowOpen from 'embercom/lib/safe-window-open';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Session from 'embercom/services/session';

interface ImpersonatedUserSearchOpenerArgs {
  user?: UserSummary | null;
  onClick: () => void;
  onSelectUser?: (user: UserSummary | null) => void;
  hideDescription?: boolean;
  asNewLead?: boolean;
}

interface Signature {
  Args: ImpersonatedUserSearchOpenerArgs;
  Element: HTMLElement;
}

export default class ImpersonatedUserSearchOpener extends Component<Signature> {
  @service declare router: RouterService;
  @service declare session: Session;
  @service declare appService: AppService;

  get isPreviewUserSelected() {
    // Preview user when no specific user is selected and not in new lead mode
    return !this.args.user && !this.args.asNewLead;
  }

  get isSpecificUserSelected() {
    // Specific user when we have a user
    return Boolean(this.args.user);
  }

  @action
  selectPreviewUser() {
    // Reset to default user mode by calling onSelectUser with null
    if (this.args.onSelectUser) {
      this.args.onSelectUser(null);
    }
  }

  @action
  selectPreviewUserAndClose(hideDropdownOverlay: () => void) {
    this.selectPreviewUser();
    hideDropdownOverlay();
  }

  @action
  selectUserOrLead() {
    // Trigger the search mode
    this.args.onClick();
  }

  @action openUserProfile() {
    if (!this.args.user) {
      return;
    }
    let url = this.router.urlFor(
      'apps.app.users.user',
      this.session.workspace.id,
      this.args.user.id,
    );
    safeWindowOpen(url, '_blank');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Impersonation::ImpersonatedUserSearchOpener': typeof ImpersonatedUserSearchOpener;
  }
}
